<template>

    <cms-view>

        <div v-if="action">
            <cms-heading :title="pageTitle">
                <cms-button icon="magicon-pencil" :to="{ name: 'action-edit', params: { id: action.id }}">Wijzigen</cms-button>
                <cms-button color="warning" v-if="action.state == 'PENDING'" :loading="updatingState" @click="markInProcess">Ingepland</cms-button>
                <cms-button icon="magicon-ok" color="highlight-2" v-if="action.state == 'IN_PROCESS'" :loading="updatingState" @click="markResolved">Afgehandeld door veldmedewerker</cms-button>
                <cms-button icon="magicon-ok" color="positive" v-if="action.state == 'RESOLVED' && userIsAdmin" :loading="updatingState" @click="markClosed">Afsluiten</cms-button>
                <cms-button color="notice" v-if="action.state == 'ON_HOLD'" :loading="updatingState" @click="markPending">Openen</cms-button>
            </cms-heading>

            <cms-view-panel>
                <tr>
                    <td class="key">Status actie</td>
                    <td><cms-text-label :title="action.state | actionState" :color="action.state | actionStateColor" /></td>
                </tr>
                <tr>
                    <td class="key">Logger</td>
                    <td><router-link :to="{ name: 'logger-view', params: { id: action.logger.id }}">{{ action.logger.serialNumber }}</router-link> ({{ action.logger.type.title }})</td>
                </tr>
                <tr>
                    <td class="key">Status logger</td>
                    <td><cms-text-label :title="action.logger.state | loggerState" :color="action.logger.state | loggerStateColor" /></td>
                </tr>
                <tr>
                    <td class="key">Project</td>
                    <td>{{ action.project.title }} ({{ action.project.code }})</td>
                </tr>
                <tr>
                    <td class="key">Aanvrager actie</td>
                    <td v-if="action.user">{{ action.user.initials }}</td>
                    <td v-else>-</td>
                </tr>
                <tr>
                    <td class="key">Projectleider</td>
                    <td>{{ action.project.projectManager | empty }}</td>
                </tr>
                <tr>
                    <td class="key">Locatie project</td>
                    <td>{{ action.project.locationManual || action.project.locationTitle }}</td>
                </tr>
                <tr>
                    <td class="key">Meetpunt</td>
                    <td>{{ action.measuringPoint }}</td>
                </tr>
                <tr>
                    <td class="key">Locatie WWD</td>
                    <td>{{ action.locationTitle | empty }}</td>
                </tr>
                <tr>
                    <td class="key">Meetfrequentie</td>
                    <td>{{ action.measuringFrequency }}</td>
                </tr>
                <tr>
                    <td class="key">Zendfrequentie</td>
                    <td>{{ action.transmissionFrequency }}</td>
                </tr>
                <tr>
                    <td class="key">Categorie&euml;n kantoor</td>
                    <td>{{ categories }}</td>
                </tr>
                <tr>
                    <td class="key">Opmerkingen kantoor</td>
                    <td>{{ action.commentsOffice }}</td>
                </tr>
                <tr>
                    <td class="key">Categorie&euml;n veld</td>
                    <td>{{ categoriesField }}</td>
                </tr>
                <tr>
                    <td class="key">Opmerkingen veld</td>
                    <td>{{ action.commentsField }}</td>
                </tr>
                <tr>
                    <td class="key">Datum van probleem</td>
                    <td>{{ action.issueDate | date('LL') }}</td>
                </tr>
                <tr>
                    <td class="key">Deadline</td>
                    <td>{{ action.deadline | actionDeadlineDate(action.issueDate) | date('LL') }}</td>
                </tr>
            </cms-view-panel>

            <template v-if="action.state == 'IN_PROCESS'">
                <cms-heading level="2" title="Logger acties"></cms-heading>
                <logger-action-grid :loggers="[action.logger]" :action-mode="true" @executed="onActionExecuted"></logger-action-grid>
            </template>
        </div>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import ActionQueries from 'app/queries/ActionQueries'
    import ActionMutations from 'app/mutations/ActionMutations'
    import actionCategoryFilter from 'app/filters/actionCategory'

    import ActionState from 'app/enums/ActionState'

    import ResolveActionModel from 'app/components/modals/ResolveActionModal.vue'

    import UserRole from 'app/enums/UserRole'

    @Component({

        name: 'view-action',
        apollo: {

            action: ActionQueries.find({

                fetchPolicy: 'cache-and-network',

                variables(){

                    return {
                        actionId: this.actionId
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                loading: 0,
                action: null,

                updatingState: false
            }
        }

        breadcrumb(){

            return [{
                title: 'Acties',
                route: {
                    name: 'actions'
                }
            }, this.pageTitle];
        }

        get pageTitle(){

            return 'Actie bekijken';
        }

        get actionId(){

            return this.$route.params.id;
        }

        get userIsAdmin(){

            return this.$user.role == UserRole.ADMIN;
        }

        get categories(){

            const formattedCategories = this.action.categories.map(actionCategoryFilter);
            return formattedCategories.join(', ');
        }

        get categoriesField(){

            const formattedCategories = this.action.categoriesField.map(actionCategoryFilter);
            return formattedCategories.join(', ');
        }

        onQueryError(){

            this.$toast.error('De actie kon niet worden opgehaald');
        }

        markResolved(){

            this.$alert.confirm('Weet je zeker dat je deze actie wilt markeren als afgehandeld door veldmedewerker?').then(({ result }) => {

                if(!result){
                    return;
                }

                this.$router.push({ name: 'action-edit', params: { id: this.action.id, mode: 'resolve' }});
            });
        }

        markInProcess(){

            this.updateState(ActionState.IN_PROCESS);
        }

        markPending(){

            this.updateState(ActionState.PENDING);
        }

        markClosed(){

            this.$modal.show(ResolveActionModel, {

                action: this.action

            }).then(({result}) => {

                if(result === true){
                    this.refetchQuery('action');
                }
            });
        }

        updateState(newState){

            this.updatingState = true;

            return ActionMutations.update({ id: this.action.id, state: newState }).then(() => {

                this.refetchQuery('action');
                this.updatingState = false;

            }).catch(error => {

                this.$logger.error('Error updating action state', error);
                this.$toast.error('De actie kon niet worden opgeslagen');

                this.updatingState = false;
            });
        }

        onActionExecuted(){

            this.refetchQuery('action');
        }
    }

</script>